// Spanish merchant application catalog, worded for Mexican Spanish speakers
// in the US. The key is the English text exactly
// as it appears in the source; a missing key falls back to that English text.
// Legal agreement text is deliberately not listed here.
import redesign from "./redesign-es";

const es = {
  ...redesign,
  // Shell
  Back: "Atrás",
  Next: "Siguiente",
  Submit: "Enviar",
  "Need Help? Call": "¿Necesita ayuda? Llame al",
  "Application Number:": "Número de solicitud:",
  Download: "Descargar",
  Close: "Cerrar",

  // Resume dialog
  "Continue where you left off?": "¿Continuar donde lo dejó?",
  "We see that you've already started an application. Would you like to continue where you left off?":
    "Vemos que ya comenzó una solicitud. ¿Desea continuar donde lo dejó?",
  "Start a New Application": "Comenzar una nueva solicitud",
  "Resume Application": "Continuar la solicitud",

  // Confirmation
  Confirmation: "Confirmación",
  "Thank You!": "¡Gracias!",
  "Your application was successfully submitted and is pending approval.":
    "Su solicitud se envió correctamente y está pendiente de aprobación.",
  "When your application is approved, we will send you an email within two business days (or sooner) that contains instructions to start processing credit cards with your new merchant account.":
    "Cuando su solicitud sea aprobada, le enviaremos un correo electrónico en un plazo de dos días hábiles (o antes) con instrucciones para comenzar a procesar tarjetas de crédito con su nueva cuenta de comerciante.",
  "Application Date:": "Fecha de la solicitud:",
  "Business Name:": "Nombre del negocio:",
  "Email Address:": "Correo electrónico:",

  // Start
  "Let's Get Started": "Comencemos",
  "This application takes about 5 minutes to complete. If you would rather apply by phone, call 888-241-8393 and an application specialist will assist you.":
    "Completar esta solicitud toma unos 5 minutos. Si prefiere hacer la solicitud por teléfono, llame al 888-241-8393 y un especialista le ayudará.",
  "Email Address": "Correo electrónico",
  "Confirm Email Address": "Confirmar correo electrónico",
  "emailname@example.com": "nombre@ejemplo.com",

  // Business
  "Business Info": "Información del negocio",
  "Let's start with some business and ownership information.":
    "Comencemos con información sobre el negocio y su propiedad.",
  "Legal Business Name": "Nombre legal del negocio",
  "Doing Business As (DBA)": "Nombre comercial (DBA)",
  "Business Description": "Descripción del negocio",
  "What type of business do you run?": "¿Qué tipo de negocio tiene?",
  "Ownership Type": "Tipo de propiedad",
  "Sole Proprietorship": "Propietario único",
  Corporation: "Corporación",
  LLC: "LLC",
  "Non Profit": "Sin fines de lucro",
  "Federal Tax ID": "Número de identificación fiscal federal",
  "What year did you open your business?": "¿En qué año abrió su negocio?",
  "Website URL (optional)": "Sitio web (opcional)",
  "http://www.website.com": "http://www.sitioweb.com",
  "Business Address": "Dirección del negocio",
  "Business Address 1": "Dirección del negocio 1",
  "Business Address 2 (optional)": "Dirección del negocio 2 (opcional)",
  "Street Address": "Calle y número",
  "Apt/Unit": "Depto./Unidad",
  City: "Ciudad",
  State: "Estado",
  "Zip Code": "Código postal",
  "Phone Number": "Número de teléfono",
  "Mailing Address different than Business Address?":
    "¿La dirección postal es diferente de la dirección del negocio?",
  "Mailing Address": "Dirección postal",
  "Mailing Address 1": "Dirección postal 1",
  "Mailing Address 2 (optional)": "Dirección postal 2 (opcional)",

  // Principal
  "Principal Info": "Información del titular",
  "Please enter your contact information so we can verify your identity.":
    "Ingrese sus datos de contacto para que podamos verificar su identidad.",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "Date of Birth": "Fecha de nacimiento",
  "Social Security Number": "Número de Seguro Social",
  "Social Security Number is encrypted and saved":
    "El Número de Seguro Social está cifrado y guardado",
  "Residence Address": "Dirección de residencia",
  "Residence Address different than Business Address?":
    "¿La dirección de residencia es diferente de la dirección del negocio?",
  "Home Address 1": "Dirección de residencia 1",
  "Home Address 2 (optional)": "Dirección de residencia 2 (opcional)",

  // Account
  "Account Info": "Información de la cuenta",
  "Please enter details on how your business operates.":
    "Ingrese los detalles sobre cómo opera su negocio.",
  "Average Sales Amount Per Customer": "Monto promedio de venta por cliente",
  "Highest Estimated Sales Amount Per Customer":
    "Monto máximo estimado de venta por cliente",
  "Estimated Monthly Credit and Debit Card Sales":
    "Ventas mensuales estimadas con tarjetas de crédito y débito",

  // Financial
  "Financial Info": "Información financiera",
  "Please enter your financial information so we can deposit money into your account.":
    "Ingrese su información financiera para que podamos depositar dinero en su cuenta.",
  "Routing Number": "Número de ruta",
  "Bank Name": "Nombre del banco",
  "Bank Account Number": "Número de cuenta bancaria",
  "Re-enter Bank Account Number": "Repita el número de cuenta bancaria",

  // Payment
  "Payment Info": "Información de pago",
  "Payment information is not required for this application.":
    "Esta solicitud no requiere información de pago.",
  "Please review the items in your cart and add your payment information to proceed.":
    "Revise los artículos de su carrito y agregue su información de pago para continuar.",
  "Payment Information": "Información de pago",
  "Card Number": "Número de tarjeta",
  "Card Type": "Tipo de tarjeta",
  "Expiration Date": "Fecha de vencimiento",
  "Card Security Code (CVV)": "Código de seguridad de la tarjeta (CVV)",
  "Billing Name": "Nombre de facturación",
  "Name on Credit Card": "Nombre en la tarjeta de crédito",
  "Billing Address": "Dirección de facturación",
  "Name on Bank Statement": "Nombre en el estado de cuenta bancario",
  "Account Type": "Tipo de cuenta",
  Checking: "Cuenta de cheques",
  Savings: "Cuenta de ahorros",
  "General Ledger": "Libro mayor",
  "Order Summary": "Resumen del pedido",
  Products: "Productos",
  "Quantity:": "Cantidad:",
  Discount: "Descuento",
  Subtotal: "Subtotal",
  Taxes: "Impuestos",
  Shipping: "Envío",
  "Order Total": "Total del pedido",
  "Credit Card": "Tarjeta de crédito",
  Free: "Gratis",
  "{count} Month Term": "Plazo en meses: {count}",
  "Down Payment": "Pago inicial",
  "Balance Due": "Saldo pendiente",

  // Review
  "Review and Submit": "Revisar y enviar",
  "I agree to the Terms and Conditions":
    "Acepto los Términos y Condiciones",
  "Terms and Conditions": "Términos y Condiciones",
  "I agree to Equipment Placement Program":
    "Acepto el Programa de Colocación de Equipos",
  "Equipment Placement Program": "Programa de Colocación de Equipos",
  "You must agree to the Terms and Conditions.":
    "Debe aceptar los Términos y Condiciones.",
  "You must agree to Equipment Placement Program.":
    "Debe aceptar el Programa de Colocación de Equipos.",
  Signature: "Firma",
  "Draw your signature with your mouse or finger:":
    "Dibuje su firma con el mouse o con el dedo:",
  "Clear Signature": "Borrar firma",
  "You must draw your signature.": "Debe dibujar su firma.",

  // Messages produced by validateStep for the merchant steps
  "Email Address is Required": "El correo electrónico es obligatorio",
  "Email is an Incorrect Format":
    "El correo electrónico tiene un formato incorrecto",
  "Email Addresses Must Match": "Los correos electrónicos deben coincidir",
  "Website address is an Incorrect Format":
    "La dirección del sitio web tiene un formato incorrecto",
  "Legal Business Name is Required": "El nombre legal del negocio es obligatorio",
  "Legal Business Name Must Be At Least 1 Character":
    "El nombre legal del negocio debe tener al menos 1 carácter",
  "Doing Business As Must Be At Least 1 Character":
    "El nombre comercial debe tener al menos 1 carácter",
  "Doing Business As is Required": "El nombre comercial es obligatorio",
  "Business Description is Required":
    "La descripción del negocio es obligatoria",
  "Ownership Type is Required": "El tipo de propiedad es obligatorio",
  "Federal Tax ID is Required":
    "El número de identificación fiscal federal es obligatorio",
  "Federal Tax ID is an Incorrect Format":
    "El número de identificación fiscal federal tiene un formato incorrecto",
  "Business Year is Required": "El año de apertura es obligatorio",
  "Business Year is an Incorrect Format":
    "El año de apertura tiene un formato incorrecto",
  "Phone Number is Required": "El número de teléfono es obligatorio",
  "Phone Number is an Incorrect Format":
    "El número de teléfono tiene un formato incorrecto",
  "Business Address 1 is Required": "La dirección del negocio 1 es obligatoria",
  "City is Required": "La ciudad es obligatoria",
  "City is an Incorrect Format": "La ciudad tiene un formato incorrecto",
  "State is Required": "El estado es obligatorio",
  "State Must be 2 Characters": "El estado debe tener 2 caracteres",
  "State is an Incorrect Format": "El estado tiene un formato incorrecto",
  "Zip Code is Required": "El código postal es obligatorio",
  "Zip Code is an Incorrect Format":
    "El código postal tiene un formato incorrecto",
  "Zip is an Incorrect Format": "El código postal tiene un formato incorrecto",
  "Business Zip Code is an Incorrect Format":
    "El código postal del negocio tiene un formato incorrecto",
  "Mailing Address is Required": "La dirección postal es obligatoria",
  "Mailing Zip Code is an Incorrect Format":
    "El código postal de la dirección postal tiene un formato incorrecto",
  "First Name is Required": "El nombre es obligatorio",
  "First Name is an Incorrect Format": "El nombre tiene un formato incorrecto",
  "Last Name is Required": "El apellido es obligatorio",
  "Last Name is an Incorrect Format": "El apellido tiene un formato incorrecto",
  "Date of Birth is Required": "La fecha de nacimiento es obligatoria",
  "Date of Birth is an Incorrect Format":
    "La fecha de nacimiento tiene un formato incorrecto",
  "Social Security Number is Required":
    "El Número de Seguro Social es obligatorio",
  "Social Security Number is an Incorrect Format":
    "El Número de Seguro Social tiene un formato incorrecto",
  "Home Address 1 is Required": "La dirección de residencia 1 es obligatoria",
  "Home Zip Code is an Incorrect Format":
    "El código postal de residencia tiene un formato incorrecto",
  "Average Sales Amount Must be Greater than $0":
    "El monto promedio de venta debe ser mayor que $0",
  "Average Sales Amount Must be no more than $50000":
    "El monto promedio de venta no debe superar $50000",
  "Highest Estimated Sales Amount Must be Greater than $0":
    "El monto máximo estimado de venta debe ser mayor que $0",
  "Highest Estimated Sales Amount Must be no more than $100000":
    "El monto máximo estimado de venta no debe superar $100000",
  "Estimated Monthly Credit and Debit Card Sales Must be Greater than 0":
    "Las ventas mensuales estimadas con tarjetas de crédito y débito deben ser mayores que 0",
  "Routing Number is Required": "El número de ruta es obligatorio",
  "Bank Name is Required": "El nombre del banco es obligatorio",
  "Bank Account Number is Required":
    "El número de cuenta bancaria es obligatorio",
  "Confirm Bank Account Number is Required":
    "Debe repetir el número de cuenta bancaria",
  "Bank Account Numbers Must Match":
    "Los números de cuenta bancaria deben coincidir",
  "Card Number is Required": "El número de tarjeta es obligatorio",
  "Card Type is Required": "El tipo de tarjeta es obligatorio",
  "CVV is Required": "El CVV es obligatorio",
  "Expiration Date is Required": "La fecha de vencimiento es obligatoria",
  "Expiration Date is an Incorrect Format":
    "La fecha de vencimiento tiene un formato incorrecto",
  "Billing Name is Required": "El nombre de facturación es obligatorio",
  "Billing Address is Required": "La dirección de facturación es obligatoria",
  "Billing Zip Code is an Incorrect Format":
    "El código postal de facturación tiene un formato incorrecto",
  "Name on Bank Statement is Required":
    "El nombre en el estado de cuenta bancario es obligatorio",
  "Account Number is Required": "El número de cuenta es obligatorio",
  "You must agree to the Terms and Conditions":
    "Debe aceptar los Términos y Condiciones",
  "You must agree to Equipment Placement Program":
    "Debe aceptar el Programa de Colocación de Equipos",
  "Signature is Required": "La firma es obligatoria",

  // Application-level failure
  "We could not load the order details. Please check the application link and try again.":
    "No pudimos cargar los detalles del pedido. Revise el enlace de la solicitud e inténtelo de nuevo."
};

export default es;
